import React from "react";

import Stock from "./stock";
import StockSupplier from "./stock-supplier";
import StockSupplierPrice from "./stock-supplier-price";
import StockLedger from "./stock-ledger";
import Supplier from "./supplier";
import Product from "./product";
import ProductStock from "./product-stock";
import ProductStockGroup from "./product-stock-group";
import Customer from "./customer";
import Order from "./order";
import OrderItem from "./order-item";
import Purchase from "./purchase";
import PurchaseItem from "./purchase-item";

export default class extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Supplier />
        <Stock />
        <StockSupplier />
        <StockSupplierPrice />
        <StockLedger />
        <Product />
        <ProductStock />
        <ProductStockGroup />
        <Customer />
        <Order />
        <OrderItem />
        <Purchase />
        <PurchaseItem />
      </React.Fragment>
    );
  }
}
